// components/ToogableTabs.js

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Typography from '../Typography';

const ToogableTabs = ({ options, activeOption, onTabChange }) => {
  return (
    <TabsContainer>
      {options.map((option) => (
        <TabButton
          key={option.value}
          className={activeOption === option.value ? 'Active' : ''}
          onClick={() => onTabChange(option.value)}
        >
          <Typography $variant="body-1-semibold">{option.label}</Typography>
        </TabButton>
      ))}
    </TabsContainer>
  );
};

ToogableTabs.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeOption: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default ToogableTabs;

// Estilos para el componente
const TabsContainer = styled.div`
  align-items: flex-start;
  background: ${props => props.theme.fill.defaultWeak};
  border-radius: ${props => props.theme.radius.md};
  display: flex;
  gap: ${props => props.theme.sizing.xs};
  padding: ${props => props.theme.sizing.xxs};
  width: 100%;
`;

const TabButton = styled.button.attrs({ type: 'button' })`
  align-items: center;
  background: none;
  border: none;
  border-radius: ${props => props.theme.radius.xl};
  cursor: pointer;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  padding: ${props => props.theme.sizing.xxs} ${props => props.theme.sizing.sm};
  transition: background 0.3s, color 0.3s;

  &.Active {
    background: ${props => props.theme.fill.defaultMain};
    box-shadow: 0 0 4px 0 rgb(0 0 0 / 8%), 
                0 4px 12px 0 rgb(0 0 0 / 4%);
  }
`;
